import * as yup from "yup";

export const restorePasswordFormSchema = yup.object().shape({
  email: yup
    .string()
    .email("Correo inválido")
    .required("El correo electrónico es requerido."),
});
